import { render, staticRenderFns } from "./SideBar_CallCenter.vue?vue&type=template&id=59052ebb&scoped=true&"
import script from "./SideBar_CallCenter.vue?vue&type=script&lang=js&"
export * from "./SideBar_CallCenter.vue?vue&type=script&lang=js&"
import style0 from "./SideBar_CallCenter.vue?vue&type=style&index=0&id=59052ebb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59052ebb",
  null
  
)

export default component.exports